<h1>{{completedGameLabel}}</h1>
